import { Alert, Button, LinearProgress } from "@mui/material";
import React from "react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function Loader(props) {
    if (props.loading) {
        return /*#__PURE__*/ _jsx("div", { style: { minWidth: 100 }, children: /*#__PURE__*/ _jsx(LinearProgress, { variant: "indeterminate" }) });
    }
    if (props.error) {
        return /*#__PURE__*/ _jsxs(Alert, { color: "error", children: [/*#__PURE__*/ _jsx("div", { children: props.error }), props.reload && /*#__PURE__*/ _jsx("div", { children: /*#__PURE__*/ _jsx(Button, { onClick: props.reload, children: "Retry" }) })] });
    }
    if (!props.result)
        return null; // @ts-ignore
    if (!props.children)
        return null; // @ts-ignore
    return /*#__PURE__*/ _jsx(_Fragment, { children: props.children(props.result) });
}
export function SmoothLoader(props) {
    return /*#__PURE__*/ _jsxs(React.Fragment, { children: [props.loading && /*#__PURE__*/ _jsx("div", { style: { minWidth: 100 }, children: /*#__PURE__*/ _jsx(LinearProgress, { variant: "indeterminate" }) }, "loading"), !props.loading && !!props.error && /*#__PURE__*/ _jsxs(Alert, { color: "error", children: [/*#__PURE__*/ _jsx("div", { children: props.error }), props.reload && /*#__PURE__*/ _jsx("div", { children: /*#__PURE__*/ _jsx(Button, { onClick: props.reload, children: "Retry" }) })] }, "error"), // @ts-ignore
            !!props.children && !!props.result && /*#__PURE__*/ _jsx(React.Fragment, { children: // @ts-ignore
                props.children(props.result) }, "data")] }, "outer");
}
export function ActionLoading(props) { if (props.loading) {
    return /*#__PURE__*/ _jsx("div", { style: { minWidth: 100 }, children: /*#__PURE__*/ _jsx(LinearProgress, { variant: "indeterminate" }) });
} return /*#__PURE__*/ _jsxs(_Fragment, { children: [!!props.error && /*#__PURE__*/ _jsx(Alert, { color: "error", children: /*#__PURE__*/ _jsx("div", { children: props.error }) }), props.children] }); }
